module.exports = "<svg viewBox=\"0 0 21 14.4\"><path fill=\"#231F20\" d=\"M10.6 14.3c-2.6 0-5.2-.1-7.8-.3-1.2-.2-2.1-1-2.2-2C0 8.7 0 5.6.6 2.4c.1-1.1 1.1-2 2.3-2 5-.4 10.2-.4 15.5 0 1.1 0 2.1.9 2.3 2.1.6 3.3.6 6.4 0 9.6-.1 1-1.1 1.9-2.2 2-2.7.1-5.3.2-7.9.2zm-7.7-1.7c5.1.4 10.3.4 15.3 0 .5-.1.9-.4.9-.8.6-3.1.6-6 0-9.2-.1-.5-.4-.8-.9-.8-5.2-.4-10.4-.4-15.4 0-.4 0-.8.4-.9.8-.6 3.1-.6 6.1 0 9.2.1.5.6.7 1 .8z\"></path><path fill=\"#231F20\" d=\"M8.1 7.2v-2c0-.5.5-.8.9-.6l2.1 1 1.8.9c.5.2.5.9 0 1.2l-1.8.9L9 9.7c-.4.2-.9-.1-.9-.6V7.2z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/youtube.svg
// module id = 323
// module chunks = 1